import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useSWR from 'swr';
import useMentionsState from '../../state/useMentionsState';
import { getUserMentions } from '../../services/dashboard.service';
import { displayErrorNotification } from '../../utils/displayNudosStandardNotifications';
import IconBadge from '../../assets/DesignSystem/SVGComponents/IconBadge';
import { SWR_KEYS } from '../../constants/constants';
import { getTotalMentions } from 'utils/getTotalMentions';

import './NotificationBell.scss';

const NotificationBell = () => {
  const { pendingViewingMentions, updateAllMentions, setIsLoading, isLoading } = useMentionsState();
  const history = useHistory();
  const [hasChangesInMentions, setHasChangesInMentions] = useState(false);
  const redirectToMentions = () => {
    if (!isLoading) {
      history.push('/dashboard/dashboard');
    }
  };

  useSWR(
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? null : SWR_KEYS.mentions,
    async () => {
      try {
        setIsLoading(true);
        const response = await getUserMentions();
        const hasChanges =
          JSON.stringify(response.pendingViewingMentions) !== JSON.stringify(pendingViewingMentions) ||
          JSON.stringify(response.pendingResolutionMentions) !== JSON.stringify([]) ||
          JSON.stringify(response.resolvedMentions) !== JSON.stringify([]);
        if (hasChanges) {
          updateAllMentions({
            pendingViewingMentions: response.pendingViewingMentions,
            pendingResolutionMentions: response.pendingResolutionMentions,
            resolvedMentions: response.resolvedMentions
          });
        }

        return response;
      } catch (error) {
        displayErrorNotification();
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    {
      refreshInterval: 60000,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      dedupingInterval: 5000
    }
  );

  const notificationCount = getTotalMentions(pendingViewingMentions);
  const displayNumber = notificationCount > 99 ? '99+' : notificationCount.toString();

  useEffect(() => {
    setHasChangesInMentions(notificationCount > 0);
  }, [notificationCount]);

  return (
    <div className={`notificationBell ${hasChangesInMentions ? 'hasChanges' : ''}`} onClick={redirectToMentions}>
      {notificationCount > 0 && <div className="numberNotification">{displayNumber}</div>}
      <div className="iconBell">
        <IconBadge />
      </div>
    </div>
  );
};

export default NotificationBell;
